// Prevents PopOver from scrolling with page when opened
export const getPopupContainer = (trigger: HTMLElement) => trigger.parentElement || trigger
